export const getSpeechRecognition = () =>
  typeof window === "undefined"
    ? null
    : (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

export const isSpeechRecognitionSupported = () => Boolean(getSpeechRecognition());
